import React, {
  createContext,
  ReactElement,
  ReactNode,
  useContext,
  useState,
} from "react"

import GlobalSearchModal from "@fuse/sharedComponents/globalSearchContext/GlobalSearchModal"

// Define the types for the context
interface GlobalSearchContextType {
  showSearchModal: () => void
  hideSearchModal: () => void
}

const GlobalSearchContext = createContext<GlobalSearchContextType | undefined>(
  undefined,
)

// Hook to use the context
export const useGlobalSearch = (): GlobalSearchContextType => {
  const context = useContext(GlobalSearchContext)
  if (!context) {
    throw new Error(
      "useGlobalSearch must be used within a GlobalSearchProvider",
    )
  }
  return context
}

// Define the props for the provider
interface GlobalSearchProviderProps {
  children: ReactNode
}

// The provider component
export const GlobalSearchProvider: React.FC<GlobalSearchProviderProps> = ({
  children,
}): ReactElement => {
  const [isSearchModalVisible, setIsSearchModalVisible] = useState(false)

  const showSearchModal = () => {
    setIsSearchModalVisible(true)
  }

  const hideSearchModal = () => {
    setIsSearchModalVisible(false)
  }

  return (
    <GlobalSearchContext.Provider value={{ showSearchModal, hideSearchModal }}>
      {children}
      {isSearchModalVisible && (
        <GlobalSearchModal hideSearchModal={hideSearchModal} />
      )}
    </GlobalSearchContext.Provider>
  )
}
